// extracted by mini-css-extract-plugin
module.exports = {"response":"TeacherList_response__2zQN0","noTab":"TeacherList_noTab__2wCmY","delete":"TeacherList_delete__1OFhd"};